export default __webpack_public_path__ + "static/media/gallery-wip-grenade v2_06.0324d0bf.jpg";